import { NgModule } from '@angular/core';
import { CommonModule, JsonPipe } from '@angular/common';
import { NgxSpinnerModule } from 'ngx-spinner';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxMaskModule } from 'ngx-mask';
import { ToastrModule } from 'ngx-toastr';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgxGraphModule } from '@swimlane/ngx-graph';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { NgOtpInputModule } from 'ng-otp-input';
import { ColorPickerModule } from 'ngx-color-picker';
import { MaterialModule } from '../material.module';
import { UserlistComponent } from '../../pages/reusablepages/user/userlist/userlist.component';
import { TeamlistComponent } from '../../pages/reusablepages/team/teamlist/teamlist.component';
import { AddteamsComponent } from '../../pages/teams/addteams/addteams.component';
import { AdduserComponent } from '../../pages/manage-user/adduser/adduser.component';
import { RelativetimePipe } from 'src/app/pipes/RelativeTime/relativetime.pipe';
import { ClaimsMonitoringStatusPipe } from 'src/app/pipes/claims-monitoring-status.pipe';
import { ViewclientComponent } from '../../pages/manage-client/viewclient/viewclient.component';
import { AddnewClaimsComponent } from '../../pages/addnew-claims/addnew-claims.component';
import { ParametersComponent } from '../../pages/parameters/parameters.component';
import { SafeHtmlPipe } from 'src/app/pipes/safe-html.pipe';

@NgModule({
  declarations: [
    // Components
    ViewclientComponent,
    UserlistComponent,
    TeamlistComponent,
    AddnewClaimsComponent,
    AddteamsComponent,
    AdduserComponent,
    ParametersComponent,

    // Pipes
    ClaimsMonitoringStatusPipe,
    RelativetimePipe,
    SafeHtmlPipe
  ],
  imports: [
    // Modules
    CommonModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    MaterialModule,
    NgxSpinnerModule,
    NgbModule,
    FontAwesomeModule,
    ToastrModule.forRoot(),
    NgxMaskModule.forRoot(),
    NgxPaginationModule,
    AutocompleteLibModule,
    BsDatepickerModule.forRoot(),
    NgxChartsModule,
    NgxGraphModule,
    NgOtpInputModule,
    NgIdleKeepaliveModule.forRoot(),
    ColorPickerModule,
    JsonPipe,
  ],
  exports: [
    // Modules
    CommonModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    MaterialModule,
    NgxSpinnerModule,
    NgbModule,
    FontAwesomeModule,
    ToastrModule,
    NgxMaskModule,
    NgxPaginationModule,
    AutocompleteLibModule,
    BsDatepickerModule,
    NgxChartsModule,
    NgxGraphModule,
    NgOtpInputModule,
    NgIdleKeepaliveModule,
    ColorPickerModule,

    // Components
    ViewclientComponent,
    UserlistComponent,
    TeamlistComponent,
    AddnewClaimsComponent,
    AddteamsComponent,
    AdduserComponent,
    ParametersComponent,

    // Pipes
    ClaimsMonitoringStatusPipe,
    RelativetimePipe,
    SafeHtmlPipe
  ]
})
export class SharedModule { }
